// extracted by mini-css-extract-plugin
export default {"moreButton":"complectationFree-module__moreButton--kLvl2"};